import { url } from '../../axios/api_urls/otherWebsite'
const api = require('../../axios/request')
import Vue from 'vue'

const state = {}

const getters = {}

const mutations = {}

const actions = {
    // 更新网站来源
    topRankingSourceupdate (context, payload) {
        return api._post(url.topRankingSourceupdate, payload)
    },
    // 查询网站来源列表
    topRankingSourcefindList (context, payload) {
        return api._post(url.topRankingSourcefindList, payload)
    },
    // 保存网站来源
    topRankingSourcesave (context, payload) {
        return api._post(url.topRankingSourcesave, payload)
    },
    // 更新网站状态
    topRankingSourceupdateStatus (context, payload) {
        return api._post(url.topRankingSourceupdateStatus, payload)
    },
    // 更新网站来源
    topRankingsave (context, payload) {
        return api._post(url.topRankingsave, payload)
    },
    // 查询网站来源列表
    topRankingupdate (context, payload) {
        return api._post(url.topRankingupdate, payload)
    },
    // 保存网站来源
    topRankingfind (context, payload) {
        return api._post(url.topRankingfind, payload)
    },
    // 更新网站状态
    topRankingfindList (context, payload) {
        return api._post(url.topRankingfindList, payload)
    },
    // 更新网站状态
    topRanking (context, payload) {
        return api._post(url.topRanking, payload)
    },
    // 获取分类列表
    topRankingSegment(context, payload) {
        return api._post(url.topRankingSegment, payload)
    },
    // check status
    topRankingupdateStatus(context, payload) {
        return api._post(url.topRankingupdateStatus, payload)
    },
    faceList(context, payload) {
        return api._post(url.faceList, payload)
    },
    topRankingfindListForFilter(context, payload) {
        return api._post(url.topRankingfindListForFilter, payload)
    },
    findByParentId(context, payload) {
        return api._post(url.findByParentId, {parentId: 296})
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/otherWebsite.js